import React from 'react';

const BarChart = ({ data, title, color = 'bg-agrosaf-green' }) => {
  const maxValue = Math.max(...data.map(item => item.value));

  return (
    <div className="w-full h-full flex flex-col">
      <div className="flex items-end justify-between flex-1 space-x-2">
        {data.map((item, index) => {
          const height = (item.value / maxValue) * 100;
          return (
            <div key={index} className="flex flex-col items-center flex-1 h-full">
              <div className="relative w-full flex flex-col justify-end flex-1">
                <div
                  className={`w-full ${color} rounded-t transition-all duration-500 hover:opacity-80`}
                  style={{ height: `${height}%` }}
                  title={`${item.label}: ${item.value}`}
                />
              </div>
              <div className="mt-2 text-xs text-gray-600 text-center flex-shrink-0">
                <div className="font-semibold">{item.label}</div>
                <div className="text-gray-500 font-bold">{item.value}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BarChart;
